export default __webpack_public_path__ + "static/media/close-filter.0f2bf93f.svg";